import { TTeamWiseEmployeeData } from '../../../types/analyticsTypes';
import { TeamMemberStats } from '../types/checkInStats';

export const deduceAverageCheckInsPercentage = (
  currentPeriod: TTeamWiseEmployeeData,
  previousPeriod: TTeamWiseEmployeeData,
): {
  totalMidDayCheckIns: number;
  totalEndDayCheckIns: number;
  prevTotalMidDayCheckIns: number;
  prevTotalEndDayCheckIns: number;
  totalCheckIns: number;
  prevTotalCheckIns: number;
  totalWorkingDays: number;
  prevTotalWorkingDays: number;
} => {
  const keys = Object.keys(currentPeriod);
  const metrics = {
    totalMidDayCheckIns: 0,
    totalEndDayCheckIns: 0,
    prevTotalMidDayCheckIns: 0,
    prevTotalEndDayCheckIns: 0,
  };
  let totalWorkingDays = 0;
  let prevTotalWorkingDays = 0;
  keys.forEach((key) => {
    const currentPeriodData = Object.values(currentPeriod[key] || {});
    const previousPeriodData = Object.values(previousPeriod[key] || {});
    currentPeriodData.forEach((data) => {
      metrics.totalMidDayCheckIns += data?.midDayCheckIns || 0;
      metrics.totalEndDayCheckIns += data?.endDayCheckIns || 0;
      totalWorkingDays += data?.totalWorkingDays || 0;
    });
    previousPeriodData.forEach((data) => {
      metrics.prevTotalMidDayCheckIns += data?.midDayCheckIns || 0;
      metrics.prevTotalEndDayCheckIns += data?.endDayCheckIns || 0;
      prevTotalWorkingDays += data?.totalWorkingDays || 0;
    });
  });
  return {
    totalMidDayCheckIns: metrics.totalMidDayCheckIns,
    totalEndDayCheckIns: metrics.totalEndDayCheckIns,
    prevTotalMidDayCheckIns: metrics.prevTotalMidDayCheckIns,
    prevTotalEndDayCheckIns: metrics.prevTotalEndDayCheckIns,
    totalCheckIns: metrics.totalMidDayCheckIns + metrics.totalEndDayCheckIns,
    prevTotalCheckIns:
      metrics.prevTotalMidDayCheckIns + metrics.prevTotalEndDayCheckIns,
    totalWorkingDays,
    prevTotalWorkingDays,
  };
};

export const sortTeamMembers = (
  teamMembers: TeamMemberStats[],
): TeamMemberStats[] =>
  teamMembers.sort((a, b) => {
    return a.averageCheckIns.percentage - b.averageCheckIns.percentage;
    // const percentageDiff =
    //   a.averageCheckIns.percentage - b.averageCheckIns.percentage;
    // if (percentageDiff !== 0) return percentageDiff;
  });
